import { createFileRoute, redirect } from "@tanstack/react-router";
import { $me } from "@/lib/auth.functions";
import { homeFor } from "@/lib/roles";

export const Route = createFileRoute("/")({
  ssr: false,
  beforeLoad: async () => {
    const user = await $me();
    throw redirect({ to: user ? homeFor(user.roles) : "/login" });
  },
  head: () => ({
    meta: [
      { title: "Clinic OS — OPD software for Indian clinics" },
      {
        name: "description",
        content:
          "Clinic OS runs the whole OPD: registration, tokens, consultation, pharmacy, lab, radiology, ICU and billing, with role-based access for every desk.",
      },
      { property: "og:title", content: "Clinic OS — OPD software for Indian clinics" },
      {
        property: "og:description",
        content:
          "Clinic OS runs the whole OPD: registration, tokens, consultation, pharmacy, lab, radiology, ICU and billing, with role-based access for every desk.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => null,
});
